// extracted by mini-css-extract-plugin
export default {"item":"informacaoBasica_item__g3k5s"};